import React from 'react';
import { Building2, Hammer, Home, HardHat } from 'lucide-react';
import { services } from '../data/mockData';
import { Card } from './ui/card';

const iconMap = {
  Building2: Building2,
  Hammer: Hammer,
  Home: Home,
  HardHat: HardHat
};

export const Services = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6">
            NAŠE SLUŽBY
          </h2>
          <p className="body-medium text-text-secondary max-w-3xl mx-auto">
            Nabízíme široké spektrum stavebních služeb s důrazem na kvalitu a profesionalitu
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="bg-bg-card border border-border-light p-8 transition-all duration-300 hover:border-brand-primary hover:shadow-xl hover:-translate-y-1"
              >
                <div className="flex items-start gap-6">
                  <div className="bg-red-50 p-4 rounded-lg shrink-0 border border-red-200">
                    <IconComponent style={{ color: '#dc143c' }} size={36} strokeWidth={2.5} />
                  </div>
                  <div>
                    <h3 className="heading-5 text-brand-primary mb-4">
                      {service.title}
                    </h3>
                    <ul className="space-y-2">
                      {service.items.map((item, idx) => (
                        <li 
                          key={idx}
                          className="body-small text-text-secondary flex items-start gap-2"
                        >
                          <span className="text-brand-primary mt-1">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
